"use client";
import React,{useEffect,useState,useContext,useMemo} from 'react'
import {Carousel} from 'react-responsive-carousel';
//import banner1 from './assets/images/Banner1.jpg'
import "react-responsive-carousel/lib/styles/carousel.min.css"; 
import banner1 from '../images/Home/banner_1.jpg'
import banner1_2x from '../images/Home/banner_1@2x.jpg'
import banner1_360 from '../images/Home/banner_1_360.jpg'
import banner1_tab from '../images/Home/banner_1_720.jpg'


import banner2 from '../images/Home/banner_2.jpg'
import banner2_2x from '../images/Home/banner_2@2x.jpg'
import banner2_360 from '../images/Home/banner_2_360.jpg'
import banner2_tab from '../images/Home/banner_2_720.jpg'


import banner3 from '../images/Home/banner_3.jpg'
import banner3_2x from '../images/Home/banner_3@2x.jpg'
import banner3_360 from '../images/Home/banner_3_360.jpg'
import banner3_tab from '../images/Home/banner_3_720.jpg'


import banner4 from '../images/Home/banner_4.jpg'
import banner4_2x from '../images/Home/banner_4@2x.jpg'
import banner4_360 from '../images/Home/banner_4_360.jpg'
import banner4_tab from '../images/Home/banner_4_720.jpg'



import banner5 from '../images/Home/banner_5.jpg'
import banner5_2x from '../images/Home/banner_5@2x.jpg'
import banner5_360 from '../images/Home/banner_5_360.jpg'
import banner5_tab from '../images/Home/banner_5_720.jpg'

//svg
// import banner4 from '../images/Home/banner_4.svg'
import {useBannerContext }  from './BannerContext'
import Image from 'next/image';

// https://github.com/leandrowd/react-responsive-carousel
const HomeBanner = ({page}) => {
  const { handleBannerLoad } = useBannerContext();

  //const banner1="https://raw.githubusercontent.com/gobisn/Images/main/Banner1.jpg";
  const [pageData, setPageData] = useState({});
  const [imagesLoaded, setImagesLoaded] = useState(0);
  const [screenWidth, setScreenWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 0);




  const bannerImages = useMemo(() => [   { src: banner4_2x.src, ban360: banner4_360.src, bantab:banner4_tab.src , srcSet: `${banner4_2x.src} 1x,${banner4_2x.src} 2x`, alt:'Ashlok Safe Earthing Electrode Limited - Manufacturing Safe Earthing Electrodes, Lightning Arrestors, and BackFill Compounds with Pan India Installation Services.' },
    { src: banner5_2x.src,ban360: banner5_360.src, bantab:banner5_tab.src , srcSet: `${banner5_2x.src} 1x,${banner5_2x.src} 2x`, alt:'Ashlok Safe Earthing Electrode Limited - Manufacturing Safe Earthing Electrodes, Lightning Arrestors, and BackFill Compounds with Pan India Installation Services.' },
    { src: banner3_2x.src,ban360: banner3_360.src, bantab:banner3_tab.src , srcSet: `${banner3_2x.src} 1x,${banner3_2x.src} 2x`,  alt:'Ashlok Safe Earthing Electrode Limited - Reliable Earthing Electrodes, BackFill Compounds, and Copper Bonded Rods for Lightning Protection.' },
    { src: banner2_2x.src,ban360: banner2_360.src, bantab:banner2_tab.src , srcSet: `${banner2_2x.src} 1x,${banner2_2x.src} 2x`, alt:'shlok Safe Earthing Electrode Limited product display featuring BackFill compounds and earthing solutions' },
    { src: banner1_2x.src,ban360: banner1_360.src, bantab:banner1_tab.src , srcSet: `${banner1_2x.src} 1x,${banner1_2x.src} 2x`,alt:'Ashlok Safe Earthing Electrode Limited 25th anniversary display for conventional lightning protection system' },
  // ], [banner1, banner1_2x, banner2, banner2_2x, banner3, banner3_2x, banner4, banner4_2x, banner5, banner5_2x]);
  ], []);

  // const bannerImages = useMemo(() => {

  //   const desktopImages = [
  //     { src: banner4_2x, alt: 'Desktop banner 4' },
  //     { src: banner5_2x, alt: 'Desktop banner 5' },
  //   ];
  //   const mobileImages = [
  //     { src: banner4, alt: 'Mobile banner 4' },
  //     { src: banner5, alt: 'Mobile banner 5' },
  //   ];
  //   console.log("scfeen width="+screenWidth);
  //   console.log(desktopImages[0]);
  //     if(screenWidth > 768)
  //     {
  //       return desktopImages;
  //     }
  //     else
  //     {
  //       return mobileImages;
  //     }
  //   //return screenWidth > 768 ? mobileImages : desktopImages;
  // }, [screenWidth]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/data/data.json');
        const data = await response.json();
        setPageData(data);
           //   console.log(data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  // }, [bannerImages]);
  }, []);

 

//   useEffect(() => {
//     bannerImages.forEach((image) => {
//         const link = document.createElement('link');
//         link.rel = 'preload';
//         link.href = image.src; // Ensure this is a string URL
//         link.as = 'image';
//         document.head.appendChild(link);

//         return () => {
//             document.head.removeChild(link);
//         };
//     });
// }, [bannerImages]);
// console.log(bannerImages[0].src);
//  console.log(bannerImages[0].srcSet);
useEffect(() => {
  bannerImages.forEach((image) => {
      // if (typeof image.src === 'string') {
          const link = document.createElement('link');
          link.as = 'image';
          link.rel = 'preload';
          link.href=image.src.src;
          
           // console.log(image.src.src);
            //  console.log(link);
            // console.log(link.href);
         
          document.head.appendChild(link);

          return () => {
            // bannerImages.forEach((image) => {
            //   if (typeof image.src === 'string') {
            //     const link = document.querySelector(`link[href="${image.src}"]`);
            //     if (link) {
            //       document.head.removeChild(link);
            //     }
            //   }
            // });
            const existingLink = document.querySelector(`link[href="${image.src.src}"]`);
              if (existingLink) {
                  document.head.removeChild(existingLink);
              }
          }
      // } else {
      //     console.warn('Invalid image source:', image.src);
      // }
  });
}, [bannerImages]);


  const handleImageLoad = () => {
    setImagesLoaded((prev) => prev + 1);
  };

  useEffect(() => {
    if (imagesLoaded === bannerImages.length) {
     
      handleBannerLoad();
    }
  
  }, [imagesLoaded, bannerImages.length, handleBannerLoad]);

  // Accessing the 'home_page_title' for the selected language
  const ban1_alt = pageData[page]?.ban1_alt || '';

/*
{/*<img data_ash_name="ban1_alt" src={banner1} alt={ban1_alt}/> }
       {/* old order start 
        <div>
          <img src={banner1} 
          srcSet={`${banner1} 1x,${banner1_2x} 2x `}/>
        </div>
        <div>
          <img src={banner2}
          srcSet={`${banner2} 1x,${banner2_2x} 2x `}/>
        </div>
        <div>
          <img src={banner3}
          srcSet={`${banner3} 1x,${banner3_2x} 2x `}/>
        </div>
        <div>
          <img src={banner4}
          srcSet={`${banner4} 1x,${banner4_2x} 2x `}/>
        </div>
        <div>
          <img src={banner5}
          srcSet={`${banner5} 1x,${banner5_2x} 2x `}/>
        </div>
  old order end }
      


*/


  return (
  
    <div className='relative w-full  bg-white   lg:h-auto sm:mt-14 lg:mt-0 ' >
      {bannerImages.length === 0 ? (
      <p>No banners available</p>
    ) : (
      
      <Carousel showArrows={false} 
      showThumbs={false} 
      axis='horizontal' 
      autoPlay={true} 
      interval={2000}
      transitionTime={500}
      showStatus={false}
      infiniteLoop={true}
      //showIndicators={false}
      >
        {bannerImages.map((image, index) => {
         // console.log('Rendering image:', image.src.src+ "     "+image.srcSet);
          return (
          <div key={index} >
            <picture className=''>
  
   <source media="(max-width: 600px)" srcSet={image.ban360} />
   
   <source media="(min-width: 601px) and (max-width: 900px)" srcSet={image.bantab} />
  <source media="(min-width: 901px)" srcSet={`${image.srcSet}`} />
  <img
    src={image.src}
    alt={image.alt}
    width={3840}
    height={900}
    className='block w-full  lg:h-auto object-cover object-center'
  />
</picture>
          
          
          
          
          {/* <Image
              src={image.src}
             
              //srcSet={image.srcSet}
              alt={image.alt}
              onLoad={handleImageLoad}
             //fill
             // className="object-cover"
             className='block w-full h-auto sm-small:h-[17vh] sm:h-[17vh] md-small:h-[30vh] md:h-[30vh] lg:h-auto object-cover'
              placeholder="blur"
              sizes="100vw"
            //   width={1920} // Intrinsic width
            //  height={390} // Intrinsic height
            //   width={3840} // Intrinsic width
            //  height={1200} // Intrinsic height
         
           // sizes="(max-width: 768px) 200vh, (max-width: 1200px) 100vh"
            // style={{
            //   width: '100%',
            //   height: 'auto',
            //   }}
        

            /> */}
          </div> );
})}


      

              </Carousel>
    )}
    </div>

  )
}

export default HomeBanner
